export default class NoUserSessionError extends Error {
  constructor() {
    super("No Firebase user session exists");
  }
}
